var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"creditPanel",style:(_vm.bgStyle),on:{"click":_vm.handleClick}},[_c('div',{staticClass:"credit"},[_c('span',{staticClass:"label"},[_vm._v("当前积分 ")]),_c('span',{staticClass:"score"},[_vm._v(_vm._s(_vm.credit))])])])}
var staticRenderFns = []

export { render, staticRenderFns }